// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__zcHyd","label":"Icon_label__2G9k9"};